import * as Yup from 'yup';
import messages from './messages';

const validateSchemaSIGNIN = Yup.object().shape({
  email: Yup.string()
    .email(messages.SIGNIN.email.formatEmail)
    .required(messages.SIGNIN.email.required),
  password: Yup.string(),
});

const validateSchemaFORGOTPASSWORD = Yup.object().shape({
  emailRecovery: Yup.string()
    .email(messages.SIGNIN.email.formatEmail)
    .required(messages.SIGNIN.email.required),
});

const recoverPasswordSchema = Yup.object().shape({
  recoverEmail: Yup.string()
    .email(messages.SIGNIN.email.formatEmail)
    .required(messages.SIGNIN.email.required),
});

const resetPasswordSchema = Yup.object().shape({
  currentPassword: Yup.string().required(messages.SIGNIN.password.required),
  newestPassword: Yup.string().required(messages.SIGNIN.password.required),
  confirmPassword: Yup.string().required(messages.SIGNIN.password.required),
});

export {
  validateSchemaSIGNIN,
  validateSchemaFORGOTPASSWORD,
  recoverPasswordSchema,
  resetPasswordSchema,
};
